import { Expose } from "class-transformer";

export class UpdateWorkplaceDto {
  @Expose()
  id: string;

  @Expose()
  name: string;

  @Expose()
  workplaceTypeId: string;

  @Expose()
  antiFallPPETypeId: string;

  @Expose()
  zoneId: string;

  @Expose()
  country?: string;

  @Expose()
  province?: string;

  @Expose()
  elevatorIds?: string[];
}
